import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './base-service.service';
import { ReservationDetailModel } from '../models/reservation-detail.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReservationDetailService   extends BaseService<ReservationDetailModel> {

  constructor(http: HttpClient) {
    super(http, `${environment.apiUrl}api/ReservationDetail`);
  }
  
    saveReservationDetails(model: ReservationDetailModel[], confirm: boolean): Observable<any> {
      return this.http.post(`${this.backUrl}/saveReservationDetails/${confirm}`, model);
    }
}
